import { defineNuxtPlugin } from '#app';
import toggleDirective from '../directives/toggle-collapse';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('toggle-collapse', toggleDirective);
});
